import { forwardRef, useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomListItem } from 'src/components/CustomListItem';
import { CustomListItemIcon } from 'src/components/CustomListItemIcon';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { GENERATION_IMPROVE_MODE, getGenerationImproveModeLabel } from 'src/data/generation';

import { LIST_ITEM_DATA_FIELD, useGetDataOverrideContextValue } from '../../lib';
import { ImproveModeIcon } from '../ImproveModeIcon';

import { useStyles } from './useStyles';

export const InternalListItem = forwardRef(
  ({ className, mode, labelOverride, onClick, selected, disabled, endIcon }, ref) => {
    const styles = useStyles();

    const getDataOverride = useGetDataOverrideContextValue();

    const handleClick = useCallback(() => {
      onClick(mode);
    }, [onClick, mode]);

    return (
      <CustomListItem
        className={cx(styles.root, className)}
        ref={ref}
        onClick={handleClick}
        selected={selected}
        disabled={disabled}
        data-testid="GenerationImproveList_Item"
        button
      >
        <CustomListItemIcon className={styles.listItemIcon}>
          {getDataOverride?.(mode, LIST_ITEM_DATA_FIELD.icon) || <ImproveModeIcon mode={mode} />}
        </CustomListItemIcon>

        <CustomTypography variant={TYPOGRAPHY_VARIANT.regular14}>
          {labelOverride ||
            getDataOverride?.(mode, LIST_ITEM_DATA_FIELD.label) ||
            getGenerationImproveModeLabel(mode)}
        </CustomTypography>

        {endIcon}
      </CustomListItem>
    );
  }
);

InternalListItem.propTypes = {
  className: PropTypes.string,
  mode: PropTypes.oneOf(Object.values(GENERATION_IMPROVE_MODE)).isRequired,
  labelOverride: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  endIcon: PropTypes.node,
};
InternalListItem.defaultProps = {
  className: '',
  labelOverride: '',
  selected: false,
  disabled: false,
  endIcon: null,
};
